import config from '../Config';
import 'whatwg-fetch';
import {
  authHeader
}
from '../utils/auth-header';
import md5 from 'md5';

export const dealerService = {
  getDealerByLocation
};


function getDealerByLocation(lat, lng, limit, filter) {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': md5(config.masterpassword + lat + lng)
    }
  };

  return fetch(
    `${config.protocol}://${config.apihost}/dealer/location/${lat}/${lng}/${limit}/${filter}`,
    requestOptions).then(
    handleResponse);
}



function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        //logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
